module.exports = "#if defined(USE_VERTEX_ID) || defined(USE_FRAGMENT_UBO)\nin vec3 id;\nout vec3 vId;\n#endif\n";